import im3d from '../img/im3d.webm';
import lsbsHero from '../img/lsb.png';
import dreamcraft from '../img/dreamcraft.jpg';
import vfusion3d from '../img/vfusion3d.jpg';
import real_humans from '../img/real_humans.webm';
import polynomials_babiloni from '../img/polynomials_babiloni.jpg';
import thesis from '../img/thesis.jpg';
import makeavideo3d from '../img/makeavideo3d.webm';
import appensetup from '../img/appen-setup.jpg';
import babiloni from '../img/babiloni.jpg';
import tothepoint from '../img/tothepoint.jpg';
import cvpr2021 from '../img/cvpr2021.jpg';
import microscopy from '../img/microscopy.jpg';
import pafu from '../img/pafu.jpg';
import tip from '../img/tip.jpg';
import cvpr_burst from '../img/cvpr_burst.jpg';
import ntua from '../img/ntua.jpg';
import eacl from '../img/eacl.jpg';
import emu3d from '../img/emu3d.webm';
import meta_3d from '../img/meta_3d.webm';
import flex3d from '../img/flex3d.webm';
import meta_llama from '../img/meta_logo.jpg';
import vgrp_bench from '../img/vgrp_bench.webp';
import wildcat from '../img/wildcat.webp';
import gen3devals from '../img/gen3devals.webm';

const publications = [
    {
        image: meta_llama,
        video: '',
        title: 'Towards Physics of Multimodal Pretraining: Knowledge Flow, Modality Synergy, Early Unification, and Recipes',
        authors: ['Junlin Han', 'Shengbang Tong', 'David Fan', 'Minghao Chen', 'Philip Torr', 'Filippos Kokkinos', 'Mike Lewis'],
        projectPage: 'https://arxiv.org/abs/2608.05000',
        arxivLink: 'https://arxiv.org/abs/2608.05000',
        conference: 'arXiv, 2026',
        mediaLink: 'https://arxiv.org/abs/2608.05000',
        selected: true,
        category: 'reasoning',
        year: 2026,
        bibtex: `@article{han2026physics,
  title={Towards Physics of Multimodal Pretraining: Knowledge Flow, Modality Synergy, Early Unification, and Recipes},
  author={Han, Junlin and Tong, Shengbang and Fan, David and Chen, Minghao and Torr, Philip and Kokkinos, Filippos and Lewis, Mike},
  journal={arXiv preprint arXiv:2608.05000},
  year={2026}
}`
    },
    {
        image: meta_llama,
        video: '',
        title: 'Reliable and Responsible Foundation Models: A Comprehensive Survey',
        authors: ['Xinyu Yang', 'Junlin Han', 'Rishi Bommasani', '...', 'Filippos Kokkinos', '...', 'Huaxiu Yao'],
        projectPage: 'https://arxiv.org/abs/2602.08145',
        arxivLink: 'https://arxiv.org/abs/2602.08145',
        conference: 'arXiv, 2026',
        mediaLink: 'https://arxiv.org/abs/2602.08145',
        selected: false,
        category: 'reasoning',
        year: 2026,
        bibtex: `@article{yang2026reliable,
  title={Reliable and Responsible Foundation Models: A Comprehensive Survey},
  author={Yang, Xinyu and Han, Junlin and Bommasani, Rishi and Kokkinos, Filippos and others},
  journal={arXiv preprint arXiv:2602.08145},
  year={2026}
}`
    },
    {
        image: lsbsHero,
        video: '',
        title: 'Learning to See Before Seeing: Demystifying LLM Visual Priors from Language Pre-training',
        authors: ['Junlin Han', 'Shengbang Tong', 'David Fan', 'Yufan Ren', 'Koustuv Sinha', 'Philip Torr', 'Filippos Kokkinos'],
        projectPage: 'https://junlinhan.github.io/projects/lsbs/',
        arxivLink: 'https://arxiv.org/abs/2509.26625',
        conference: 'ICLR, 2026',
        mediaLink: 'https://junlinhan.github.io/projects/lsbs/',
        selected: true,
        category: 'reasoning',
        year: 2026,
        bibtex: `@inproceedings{han2026learning,
  title={Learning to See Before Seeing: Demystifying LLM Visual Priors from Language Pre-training},
  author={Han, Junlin and Tong, Shengbang and Fan, David and Ren, Yufan and Sinha, Koustuv and Torr, Philip and Kokkinos, Filippos},
  booktitle={International Conference on Learning Representations (ICLR)},
  year={2026}
}`
    },
    {
        image: wildcat,
        video: '',
        title: 'WildCAT3D: Appearance-Aware Multi-View Diffusion in the Wild',
        authors: ['Morris Alper', 'David Novotny', 'Filippos Kokkinos', 'Hadar Averbuch-Elor', 'Tom Monnier'],
        projectPage: 'https://wildcat3d.github.io/',
        arxivLink: 'https://arxiv.org/abs/2506.13030',
        conference: 'NeurIPS, 2025',
        mediaLink: 'https://wildcat3d.github.io/',
        selected: true,
        category: '3d-gen',
        year: 2025,
        bibtex: `@inproceedings{alper2025wildcat3d,
  title={WildCAT3D: Appearance-Aware Multi-View Diffusion in the Wild},
  author={Alper, Morris and Novotny, David and Kokkinos, Filippos and Averbuch-Elor, Hadar and Monnier, Tom},
  booktitle={Advances in Neural Information Processing Systems (NeurIPS)},
  year={2025}
}`
    },
    {
        image: '',
        video: gen3devals,
        title: 'Gen3DEval: Using vLLMs for Automatic Evaluation of Generated 3D Objects',
        authors: ['Shalini Maiti', 'Lourdes Agapito', 'Filippos Kokkinos'],
        projectPage: 'https://shalini-maiti.github.io/gen3deval.github.io/',
        arxivLink: 'https://arxiv.org/abs/2504.08125',
        conference: 'CVPR, 2025',
        mediaLink: 'https://shalini-maiti.github.io/gen3deval.github.io/',
        selected: true,
        category: '3d-gen',
        year: 2025,
        bibtex: `@inproceedings{maiti2025gen3deval,
  title={Gen3DEval: Using vLLMs for Automatic Evaluation of Generated 3D Objects},
  author={Maiti, Shalini and Agapito, Lourdes and Kokkinos, Filippos},
  booktitle={IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR)},
  year={2025}
}`
    },
    {
        image: vgrp_bench,
        video: '',
        title: 'VGRP-Bench: Visual Grid Reasoning Puzzle Benchmark for Large Vision-Language Models',
        authors: ['Yufan Ren', 'Konstantinos Tertikas', 'Shalini Maiti', 'Junlin Han', 'Tong Zhang', 'Sabine Süsstrunk', 'Filippos Kokkinos'],
        projectPage: 'https://yufan-ren.com/subpage/VGRP-Bench/',
        arxivLink: 'https://arxiv.org/abs/2503.23064',
        conference: 'arXiv, 2025',
        mediaLink: 'https://yufan-ren.com/subpage/VGRP-Bench/',
        selected: false,
        category: 'reasoning',
        year: 2025,
        bibtex: `@article{ren2025vgrp,
  title={VGRP-Bench: Visual Grid Reasoning Puzzle Benchmark for Large Vision-Language Models},
  author={Ren, Yufan and Tertikas, Konstantinos and Maiti, Shalini and Han, Junlin and Zhang, Tong and S{"u}sstrunk, Sabine and Kokkinos, Filippos},
  journal={arXiv preprint arXiv:2503.23064},
  year={2025}
}`
    },
    {
        image: meta_llama,
        video: '',
        title: 'The Llama 3 Herd of Models',
        authors: ['Llama Team', 'Meta AI'],
        projectPage: 'https://ai.meta.com/blog/meta-llama-3/',
        arxivLink: 'https://arxiv.org/abs/2407.21783',
        conference: 'arXiv, 2024',
        mediaLink: 'https://ai.meta.com/blog/meta-llama-3/',
        selected: true,
        category: 'reasoning',
        year: 2024,
        bibtex: `@article{dubey2024llama,
  title={The Llama 3 Herd of Models},
  author={{Llama Team, Meta AI}},
  journal={arXiv preprint arXiv:2407.21783},
  year={2024}
}`
    },
    {
        image: '',
        video: flex3d,
        title: 'Flex3D: Feed-Forward 3D Generation With Flexible Reconstruction Model And Input View Curation',
        authors: ['Junlin Han', 'Jianyuan Wang', 'Andrea Vedaldi', 'Philip Torr', 'Filippos Kokkinos'],
        projectPage: 'https://junlinhan.github.io/projects/flex3d/',
        arxivLink: 'https://arxiv.org/abs/2410.00890',
        conference: 'arXiv, 2024',
        mediaLink: 'https://junlinhan.github.io/projects/flex3d/',
        selected: false,
        category: '3d-gen',
        year: 2024,
        bibtex: `@article{han2024flex3d,
  title={Flex3D: Feed-Forward 3D Generation With Flexible Reconstruction Model And Input View Curation},
  author={Han, Junlin and Wang, Jianyuan and Vedaldi, Andrea and Torr, Philip and Kokkinos, Filippos},
  journal={arXiv preprint arXiv:2410.00890},
  year={2024}
}`
    },
    {
        image: '',
        video: meta_3d,
        title: 'Meta 3D Gen',
        authors: ['Raphael Bensadoun*', 'Tom Monnier*', 'Yanir Kleiman*', 'Filippos Kokkinos', 'Yawar Siddiqui', 'Mahendra Kariya', 'Omri Harosh', 'Roman Shapovalov', 'Benjamin Graham', 'Emilien Garreau', 'Animesh Karnewar', 'Ang Cao', 'Idan Azuri', 'Iurii Makarov', 'Eric-Tuan Le', 'Antoine Toisoul', 'David Novotny', 'Oran Gafni', 'Natalia Neverova', 'Andrea Vedaldi'],
        projectPage: 'https://ai.meta.com/research/publications/meta-3d-gen/',
        arxivLink: 'https://arxiv.org/abs/2407.02599',
        conference: 'arXiv, 2024',
        mediaLink: 'https://ai.meta.com/research/publications/meta-3d-gen/',
        selected: true,
        category: '3d-gen',
        year: 2024,
        bibtex: `@article{bensadoun2024meta,
  title={Meta 3D Gen},
  author={Bensadoun, Raphael and Monnier, Tom and Kleiman, Yanir and Kokkinos, Filippos and Siddiqui, Yawar and others},
  journal={arXiv preprint arXiv:2407.02599},
  year={2024}
}`
    },
    {
        image: '',
        video: emu3d,
        title: 'Meta 3D AssetGen: Text-to-Mesh Generation with High-Quality Geometry, Texture, and PBR Materials',
        authors: ['Yawar Siddiqui*', 'Tom Monnier*', 'Filippos Kokkinos*', 'Mahendra Kariya', 'Yanir Kleiman', 'Emilien Garreau', 'Oran Gafni', 'Natalia Neverova', 'Andrea Vedaldi', 'David Novotny*', 'Roman Shapovalov*'],
        projectPage: 'https://assetgen.github.io/',
        arxivLink: 'https://arxiv.org/abs/2407.02445',
        conference: 'NeurIPS, 2024',
        mediaLink: 'https://assetgen.github.io/',
        selected: true,
        category: '3d-gen',
        year: 2024,
        bibtex: `@inproceedings{siddiqui2024meta,
  title={Meta 3D AssetGen: Text-to-Mesh Generation with High-Quality Geometry, Texture, and PBR Materials},
  author={Siddiqui, Yawar and Monnier, Tom and Kokkinos, Filippos and Kariya, Mahendra and Kleiman, Yanir and Garreau, Emilien and Gafni, Oran and Neverova, Natalia and Vedaldi, Andrea and Novotny, David and Shapovalov, Roman},
  booktitle={Advances in Neural Information Processing Systems (NeurIPS)},
  year={2024}
}`
    },
    {
        image: dreamcraft,
        video: '',
        title: 'DreamCraft: Text-Guided Generation of Functional 3D Environments in Minecraft',
        authors: ['Sam Earle', 'Filippos Kokkinos', 'Yuhe Nie', 'Julian Togelius', 'Roberta Raileanu'],
        projectPage: 'https://arxiv.org/abs/2404.15538',
        arxivLink: 'https://arxiv.org/abs/2404.15538',
        conference: 'FDG, 2024',
        mediaLink: 'https://arxiv.org/abs/2404.15538',
        selected: false,
        category: '3d-gen',
        year: 2024,
        bibtex: `@inproceedings{earle2024dreamcraft,
  title={DreamCraft: Text-Guided Generation of Functional 3D Environments in Minecraft},
  author={Earle, Sam and Kokkinos, Filippos and Nie, Yuhe and Togelius, Julian and Raileanu, Roberta},
  booktitle={Foundations of Digital Games (FDG)},
  year={2024}
}`
    },
    {
        image: vfusion3d,
        video: '',
        title: 'Vfusion3D: Learning Scalable 3D Generative Models from Video Diffusion Models',
        authors: ['Junlin Han', 'Filippos Kokkinos', 'Philip Torr'],
        projectPage: 'https://junlinhan.github.io/projects/vfusion3d.html',
        arxivLink: 'https://arxiv.org/abs/2403.12034',
        conference: 'ECCV, 2024',
        mediaLink: 'https://junlinhan.github.io/projects/vfusion3d.html',
        selected: true,
        category: '3d-gen',
        year: 2024,
        bibtex: `@inproceedings{han2024vfusion3d,
  title={Vfusion3D: Learning Scalable 3D Generative Models from Video Diffusion Models},
  author={Han, Junlin and Kokkinos, Filippos and Torr, Philip},
  booktitle={European Conference on Computer Vision (ECCV)},
  year={2024}
}`
    },
    {
        image: '',
        video: im3d,
        title: 'IM-3D: Iterative Multiview Diffusion and Reconstruction for High-Quality 3D Generation',
        authors: ['Luke Melas-Kyriazi*', 'Iro Laina', 'Christian Rupprecht', 'Natalia Neverova', 'Andrea Vedaldi', 'Oran Gafni', 'Filippos Kokkinos*'],
        projectPage: 'https://lukemelas.github.io/IM-3D/',
        arxivLink: 'https://arxiv.org/abs/2402.08682',
        conference: 'ICML, 2024',
        mediaLink: 'https://lukemelas.github.io/IM-3D/',
        selected: true,
        category: '3d-gen',
        year: 2024,
        bibtex: `@inproceedings{melaskyriazi2024im3d,
  title={IM-3D: Iterative Multiview Diffusion and Reconstruction for High-Quality 3D Generation},
  author={Melas-Kyriazi, Luke and Laina, Iro and Rupprecht, Christian and Neverova, Natalia and Vedaldi, Andrea and Gafni, Oran and Kokkinos, Filippos},
  booktitle={International Conference on Machine Learning (ICML)},
  year={2024}
}`
    },
    {
        image: '',
        video: real_humans,
        title: 'Real-time Volumetric Rendering of Dynamic Humans',
        authors: ['Ignacio Rocco', 'Iurii Makarov', 'Filippos Kokkinos', 'David Novotny', 'Benjamin Graham', 'Natalia Neverova', 'Andrea Vedaldi'],
        projectPage: 'https://real-time-humans.github.io/',
        arxivLink: 'https://arxiv.org/abs/2303.11898',
        conference: 'arXiv, 2023',
        mediaLink: 'https://real-time-humans.github.io/',
        selected: false,
        category: 'neural-rendering',
        year: 2023,
        bibtex: `@article{rocco2023realtime,
  title={Real-time Volumetric Rendering of Dynamic Humans},
  author={Rocco, Ignacio and Makarov, Iurii and Kokkinos, Filippos and Novotny, David and Graham, Benjamin and Neverova, Natalia and Vedaldi, Andrea},
  journal={arXiv preprint arXiv:2303.11898},
  year={2023}
}`
    },
    {
        image: polynomials_babiloni,
        video: '',
        title: 'Linear Complexity Self-Attention With 3rd Order Polynomials',
        authors: ['Francesca Babiloni', 'Ioannis Marras', 'Jiankang Deng', 'Filippos Kokkinos', 'Matteo Maggioni', 'Grigorios Chrysos', 'Philip Torr', 'Stefanos Zafeiriou'],
        projectPage: 'https://ieeexplore.ieee.org/abstract/document/10076897',
        arxivLink: 'https://ieeexplore.ieee.org/abstract/document/10076897',
        conference: 'IEEE TPAMI, 2023',
        mediaLink: 'https://ieeexplore.ieee.org/abstract/document/10076897',
        selected: false,
        category: 'vision',
        year: 2023,
        bibtex: `@article{babiloni2023linear,
  title={Linear Complexity Self-Attention With 3rd Order Polynomials},
  author={Babiloni, Francesca and Marras, Ioannis and Deng, Jiankang and Kokkinos, Filippos and Maggioni, Matteo and Chrysos, Grigorios and Torr, Philip and Zafeiriou, Stefanos},
  journal={IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI)},
  year={2023}
}`
    },
    {
        image: thesis,
        video: '',
        title: 'Deep Structured Layers for Instance-Level Optimization in 2D and 3D Vision',
        authors: ['Filippos Kokkinos'],
        projectPage: 'https://discovery.ucl.ac.uk/id/eprint/10164015/',
        arxivLink: 'https://discovery.ucl.ac.uk/id/eprint/10164015/1/Kokkinos_Main.pdf',
        conference: 'Ph.D. Thesis, UCL, 2021',
        mediaLink: 'https://discovery.ucl.ac.uk/id/eprint/10164015/',
        selected: false,
        category: 'vision',
        year: 2021,
        bibtex: `@phdthesis{kokkinos2021deep,
  title={Deep Structured Layers for Instance-Level Optimization in 2D and 3D Vision},
  author={Kokkinos, Filippos},
  school={University College London (UCL)},
  year={2021}
}`
    },
    {
        image: '',
        video: makeavideo3d,
        title: 'Text-To-4D Dynamic Scene Generation',
        authors: ['Uriel Singer*', 'Shelly Sheynin*', 'Adam Polyak*', 'Oron Ashual', 'Iurii Makarov', 'Filippos Kokkinos', 'Naman Goyal', 'Andrea Vedaldi', 'Devi Parikh', 'Justin Johnson', 'Yaniv Taigman'],
        projectPage: 'https://make-a-video3d.github.io/',
        arxivLink: 'https://arxiv.org/abs/2301.11280',
        conference: 'ICML, 2023',
        mediaLink: 'https://make-a-video3d.github.io/',
        selected: false,
        category: '3d-gen',
        year: 2023,
        bibtex: `@inproceedings{singer2023text4d,
  title={Text-To-4D Dynamic Scene Generation},
  author={Singer, Uriel and Sheynin, Shelly and Polyak, Adam and Ashual, Oron and Makarov, Iurii and Kokkinos, Filippos and Goyal, Naman and Vedaldi, Andrea and Parikh, Devi and Johnson, Justin and Taigman, Yaniv},
  booktitle={International Conference on Machine Learning (ICML)},
  year={2023}
}`
    },
    {
        image: appensetup,
        video: '',
        title: 'Replay: Multi-modal Multi-view Acted Videos for Casual Holography',
        authors: ['Roman Shapovalov', 'Yanir Kleiman', 'Ignacio Rocco', 'David Novotny', 'Andrea Vedaldi', 'Changan Chen', 'Filippos Kokkinos', 'Ben Graham', 'Natalia Neverova'],
        projectPage: 'https://replay-dataset.github.io/',
        arxivLink: 'https://arxiv.org/abs/2307.12067',
        conference: 'ICCV, 2023',
        mediaLink: 'https://replay-dataset.github.io/',
        selected: false,
        category: 'neural-rendering',
        year: 2023,
        bibtex: `@inproceedings{shapovalov2023replay,
  title={Replay: Multi-modal Multi-view Acted Videos for Casual Holography},
  author={Shapovalov, Roman and Kleiman, Yanir and Rocco, Ignacio and Novotny, David and Vedaldi, Andrea and Chen, Changan and Kokkinos, Filippos and Graham, Ben and Neverova, Natalia},
  booktitle={IEEE/CVF International Conference on Computer Vision (ICCV)},
  year={2023}
}`
    },
    {
        image: babiloni,
        video: '',
        title: 'Poly-NL: Linear Complexity Non-local Layers with Polynomials',
        authors: ['Francesca Babiloni', 'Ioannis Marras', 'Filippos Kokkinos', 'Jiankang Deng', 'Grigorios Chrysos', 'Stefanos Zafeiriou'],
        projectPage: 'https://arxiv.org/abs/2107.02859',
        arxivLink: 'https://arxiv.org/abs/2107.02859',
        conference: 'ICCV, 2021',
        mediaLink: 'https://arxiv.org/abs/2107.02859',
        selected: false,
        category: 'vision',
        year: 2021,
        bibtex: `@inproceedings{babiloni2021polynl,
  title={Poly-NL: Linear Complexity Non-local Layers with Polynomials},
  author={Babiloni, Francesca and Marras, Ioannis and Kokkinos, Filippos and Deng, Jiankang and Chrysos, Grigorios and Zafeiriou, Stefanos},
  booktitle={IEEE/CVF International Conference on Computer Vision (ICCV)},
  year={2021}
}`
    },
    {
        image: tothepoint,
        video: '',
        title: 'To The Point: Correspondence-driven Monocular 3D Category Reconstruction',
        authors: ['Filippos Kokkinos', 'Iasonas Kokkinos'],
        projectPage: 'https://fkokkinos.github.io/to_the_point/',
        arxivLink: 'https://fkokkinos.github.io/to_the_point/resources/pdf/paper.pdf',
        conference: 'NeurIPS, 2021',
        mediaLink: 'https://fkokkinos.github.io/to_the_point/',
        selected: false,
        category: 'vision',
        year: 2021,
        bibtex: `@inproceedings{kokkinos2021point,
  title={To The Point: Correspondence-driven Monocular 3D Category Reconstruction},
  author={Kokkinos, Filippos and Kokkinos, Iasonas},
  booktitle={Advances in Neural Information Processing Systems (NeurIPS)},
  year={2021}
}`
    },
    {
        image: cvpr2021,
        video: '',
        title: 'Learning Monocular 3D Reconstruction of Articulated Categories from Motion',
        authors: ['Filippos Kokkinos', 'Iasonas Kokkinos'],
        projectPage: 'https://fkokkinos.github.io/video_3d_reconstruction/',
        arxivLink: 'https://arxiv.org/abs/2104.09579',
        conference: 'CVPR, 2021',
        mediaLink: 'https://fkokkinos.github.io/video_3d_reconstruction/',
        selected: false,
        category: 'vision',
        year: 2021,
        bibtex: `@inproceedings{kokkinos2021learning,
  title={Learning Monocular 3D Reconstruction of Articulated Categories from Motion},
  author={Kokkinos, Filippos and Kokkinos, Iasonas},
  booktitle={IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR)},
  year={2021}
}`
    },
    {
        image: microscopy,
        video: '',
        title: 'Microscopy Image Restoration with Deep Wiener-Kolmogorov Filters',
        authors: ['Valeriya Pronina', 'Filippos Kokkinos', 'Dmitry V. Dylov', 'Stamatios Lefkimmiatis'],
        projectPage: 'https://arxiv.org/abs/1911.10989',
        arxivLink: 'https://arxiv.org/abs/1911.10989',
        conference: 'ECCV, 2020',
        mediaLink: 'https://arxiv.org/abs/1911.10989',
        selected: false,
        category: 'vision',
        year: 2020,
        bibtex: `@inproceedings{pronina2020microscopy,
  title={Microscopy Image Restoration with Deep Wiener-Kolmogorov Filters},
  author={Pronina, Valeriya and Kokkinos, Filippos and Dylov, Dmitry V and Lefkimmiatis, Stamatios},
  booktitle={European Conference on Computer Vision (ECCV)},
  year={2020}
}`
    },
    {
        image: pafu,
        video: '',
        title: 'Pixel Adaptive Filtering Units',
        authors: ['Filippos Kokkinos', 'Ioannis Marras', 'Matteo Maggioni', 'Gregory Slabaugh', 'Stefanos Zafeiriou'],
        projectPage: 'https://arxiv.org/abs/1911.10581',
        arxivLink: 'https://arxiv.org/abs/1911.10581',
        conference: 'arXiv, 2019',
        mediaLink: 'https://arxiv.org/abs/1911.10581',
        selected: false,
        category: 'vision',
        year: 2019,
        bibtex: `@article{kokkinos2019pixel,
  title={Pixel Adaptive Filtering Units},
  author={Kokkinos, Filippos and Marras, Ioannis and Maggioni, Matteo and Slabaugh, Gregory and Zafeiriou, Stefanos},
  journal={arXiv preprint arXiv:1911.10581},
  year={2019}
}`
    },
    {
        image: tip,
        video: '',
        title: 'Iterative Joint Image Demosaicking and Denoising Using a Residual Denoising Network',
        authors: ['Filippos Kokkinos', 'Stamatios Lefkimmiatis'],
        projectPage: 'https://ieeexplore.ieee.org/abstract/document/8668795',
        arxivLink: 'https://arxiv.org/abs/1807.06403',
        conference: 'IEEE TIP, 2019',
        mediaLink: 'https://arxiv.org/abs/1807.06403',
        selected: false,
        category: 'vision',
        year: 2019,
        bibtex: `@article{kokkinos2019iterative,
  title={Iterative Joint Image Demosaicking and Denoising Using a Residual Denoising Network},
  author={Kokkinos, Filippos and Lefkimmiatis, Stamatios},
  journal={IEEE Transactions on Image Processing (TIP)},
  year={2019}
}`
    },
    {
        image: cvpr_burst,
        video: '',
        title: 'Iterative Residual CNNs for Burst Photography Applications',
        authors: ['Filippos Kokkinos', 'Stamatios Lefkimmiatis'],
        projectPage: 'https://fkokkinos.github.io/deep_burst/',
        arxivLink: 'https://arxiv.org/abs/1811.12197',
        conference: 'CVPR, 2019',
        mediaLink: 'https://fkokkinos.github.io/deep_burst/',
        selected: false,
        category: 'vision',
        year: 2019,
        bibtex: `@inproceedings{kokkinos2019iterative_burst,
  title={Iterative Residual CNNs for Burst Photography Applications},
  author={Kokkinos, Filippos and Lefkimmiatis, Stamatios},
  booktitle={IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR)},
  year={2019}
}`
    },
    {
        image: tip,
        video: '',
        title: 'Deep Image Demosaicking using a Cascade of Convolutional Residual Denoising Networks',
        authors: ['Filippos Kokkinos', 'Stamatios Lefkimmiatis'],
        projectPage: 'https://arxiv.org/abs/1803.05215',
        arxivLink: 'https://arxiv.org/abs/1803.05215',
        conference: 'ECCV, 2018',
        mediaLink: 'https://arxiv.org/abs/1803.05215',
        selected: false,
        category: 'vision',
        year: 2018,
        bibtex: `@inproceedings{kokkinos2018deep,
  title={Deep Image Demosaicking using a Cascade of Convolutional Residual Denoising Networks},
  author={Kokkinos, Filippos and Lefkimmiatis, Stamatios},
  booktitle={European Conference on Computer Vision (ECCV)},
  year={2018}
}`
    },
    {
        image: eacl,
        video: '',
        title: 'Structural Attention Neural Networks for Improved Sentiment Analysis',
        authors: ['Filippos Kokkinos', 'Alexandros Potamianos'],
        projectPage: 'https://arxiv.org/abs/1701.01811',
        arxivLink: 'https://arxiv.org/abs/1701.01811',
        conference: 'EACL, 2017',
        mediaLink: 'https://arxiv.org/abs/1701.01811',
        selected: false,
        category: 'reasoning',
        year: 2017,
        bibtex: `@inproceedings{kokkinos2017structural,
  title={Structural Attention Neural Networks for Improved Sentiment Analysis},
  author={Kokkinos, Filippos and Potamianos, Alexandros},
  booktitle={European Chapter of the Association for Computational Linguistics (EACL)},
  year={2017}
}`
    },
    {
        image: ntua,
        video: '',
        title: 'Tweester at SemEval-2017 Task 4: Fusion of Semantic-Affective and Pairwise Classification Models',
        authors: ['Athanasia Kolovou', 'Filippos Kokkinos', 'Aris Fergadis', 'Pinelopi Papalampidi', 'Elias Iosif', 'Nikolaos Malandrakis', 'Elisavet Palogiannidi', 'Harris Papageorgiou', 'Shrikanth Narayanan', 'Alexandros Potamianos'],
        projectPage: 'https://aclanthology.org/S17-2112/',
        arxivLink: 'https://aclanthology.org/S17-2112/',
        conference: 'ACL SemEval, 2017',
        mediaLink: 'https://aclanthology.org/S17-2112/',
        selected: false,
        category: 'reasoning',
        year: 2017,
        bibtex: `@inproceedings{kolovou2017tweester,
  title={Tweester at SemEval-2017 Task 4: Fusion of Semantic-Affective and Pairwise Classification Models for Sentiment Analysis in Twitter},
  author={Kolovou, Athanasia and Kokkinos, Filippos and Fergadis, Aris and Papalampidi, Pinelopi and others},
  booktitle={International Workshop on Semantic Evaluation (SemEval)},
  year={2017}
}`
    },
    {
        image: ntua,
        video: '',
        title: 'Tweester at SemEval-2016 Task 4: Sentiment Analysis in Twitter Using Semantic-Affective Model Adaptation',
        authors: ['Elisavet Palogiannidi', 'Athanasia Kolovou', 'Fenia Christopoulou', 'Filippos Kokkinos', 'Elias Iosif', 'Nikolaos Malandrakis', 'Harris Papageorgiou', 'Shrikanth Narayanan', 'Alexandros Potamianos'],
        projectPage: 'https://aclanthology.org/S16-1023.pdf',
        arxivLink: 'https://aclanthology.org/S16-1023.pdf',
        conference: 'ACL SemEval, 2016',
        mediaLink: 'https://aclanthology.org/S16-1023.pdf',
        selected: false,
        category: 'reasoning',
        year: 2016,
        bibtex: `@inproceedings{palogiannidi2016tweester,
  title={Tweester at SemEval-2016 Task 4: Sentiment Analysis in Twitter Using Semantic-Affective Model Adaptation},
  author={Palogiannidi, Elisavet and Kolovou, Athanasia and Christopoulou, Fenia and Kokkinos, Filippos and others},
  booktitle={International Workshop on Semantic Evaluation (SemEval)},
  year={2016}
}`
    }
];

export default publications;
